import Timing from './timing.vue';

export default Timing;



// WEBPACK FOOTER //
// ./src/components/timing/index.js